import { render, staticRenderFns } from "./AddCms.vue?vue&type=template&id=61da77fb&"
import script from "./AddCms.vue?vue&type=script&lang=js&"
export * from "./AddCms.vue?vue&type=script&lang=js&"
import style0 from "./AddCms.vue?vue&type=style&index=0&id=61da77fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports